import { render, staticRenderFns } from "./StdSubItemTxtForm.vue?vue&type=template&id=0e34a1d8&"
import script from "./StdSubItemTxtForm.vue?vue&type=script&lang=js&"
export * from "./StdSubItemTxtForm.vue?vue&type=script&lang=js&"
import style0 from "./StdSubItemTxtForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdSubItemTxtForm.vue"
export default component.exports